var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kpi-page" },
    [
      _vm._m(0),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.loadCurrent },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "KPI计划", name: "kpi" } }),
          _c("el-tab-pane", { attrs: { label: "奖罚绩效", name: "reward" } }),
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "status",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _vm.tab === "kpi"
                ? _c(
                    "el-form-item",
                    [
                      _c("el-button", { on: { click: _vm.openKpi } }, [
                        _vm._v("制订KPI"),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    [
                      _c("el-button", { on: { click: _vm.openReward } }, [
                        _vm._v("登记奖罚"),
                      ]),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _vm.tab === "kpi"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.tableData.data, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "plan.planNo",
                      label: "编号",
                      "min-width": "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "plan.name",
                      label: "名称",
                      "min-width": "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "plan.metricCode",
                      label: "指标",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "目标/完成", width: "140" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                _vm._s(row.plan.targetValue) +
                                  " / " +
                                  _vm._s(
                                    row.result ? row.result.actualValue : 0
                                  )
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      17704516
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(_vm._s(_vm.planText(row.plan.status))),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      273284793
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "280" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return _vm._l(row.actions, function (action) {
                              return _c(
                                "el-button",
                                {
                                  key: action,
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.runKpi(row, action)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.actionText(action)))]
                              )
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      657576101
                    ),
                  }),
                ],
                1
              )
            : _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.tableData.data, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "record.recordNo",
                      label: "编号",
                      "min-width": "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "staffName", label: "职员", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "类型", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                row.record.recordType === "reward"
                                  ? "奖励"
                                  : "处罚"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "金额", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(Number(row.record.amount || 0).toFixed(2))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(_vm._s(_vm.rewardText(row.record.status))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "240" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return _vm._l(row.actions, function (action) {
                            return _c(
                              "el-button",
                              {
                                key: action,
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runReward(row, action)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.actionText(action)))]
                            )
                          })
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, prev, pager, next",
                  total: _vm.tableData.total,
                },
                on: { "current-change": _vm.handleCurrentChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("KPI & PERFORMANCE")]),
        _c("h2", [_vm._v("KPI 与奖罚")]),
        _c("p", [
          _vm._v("草稿启用后重算确认；奖罚待审、生效、核销写入经营账户。"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }